import { Fragment } from "react";
import Footer from "../../component/layout/footer";
import Header from "../../component/layout/header";
import PageHeader from "../../component/layout/pageheader";
import Progress from "../../component/sidebar/progress";
import Rating from "../../component/sidebar/rating";
import { Link } from "react-router-dom";

// ----- Main Tutor Details -----
const mainTutor = {
    name: "John Mathews",
    photo: "assets/images/instructor/single/01.jpg",
    degree: "Master of Performing Arts",
    desc: "John Mathews specializes in stage performance, microphone handling, and public singing techniques to boost confidence on stage.",
    subTitle: "Personal Statement",
    infoDetails: "With years of experience in live performances, John mentors students to excel in stage presence, audience engagement, and performance consistency.",
    address: "23 Broadway Avenue, Stage City, USA",
    email: "johnmathews@example.com",
    phone: "+1 234 567 8901",
    website: "www.stageperformancepro.com",
    category: "Stage Performance",
    specialization: "Live Singing & Stage Confidence",
    experience: "12 Years Experience",
};

// ----- Skills & Awards -----
const skillList = [
    { percentage: '90', text: 'Stage Presence' },
    { percentage: '85', text: 'Mic Handling' },
    { percentage: '80', text: 'Audience Engagement' },
];

const awardList = [
    { imgUrl: 'assets/images/instructor/single/icon/01.png', imgAlt: 'Award', text: 'Beginner Vocalist 2019' },
    { imgUrl: 'assets/images/instructor/single/icon/02.png', imgAlt: 'Award', text: 'Rising Star Singer 2020' },
    { imgUrl: 'assets/images/instructor/single/icon/03.png', imgAlt: 'Award', text: 'Music Excellence 2021' },
];

// ----- Related Tutors -----
const relatedTutors = [
    { name: "Alex Morgan", category: "Western Singing", experience: "6 Years", photo: "assets/images/instructor/13.jpg",link: "/westerntutor" },
    { name: "Vishnu Priya", category: "Indian Classical Singing", experience: "10 Years", photo: "assets/images/instructor/14.jpg", link: "/classical-tutor" },
    { name: "Rajib Raj", category: "Western & Classical Singing", experience: "8 Years", photo: "assets/images/instructor/15.jpg", link:"/beginner-tutor" },
];

// ----- Advertisement Banners -----
const adsList = [
    { imgUrl: "assets/images/art/Sing1.png", alt: "Ad 1" },
    { imgUrl: "assets/images/art/Sing2.png", alt: "Ad 2" },
    { imgUrl: "assets/images/art/Sing3.png", alt: "Ad 3" },
];

const StageTutor = () => {
    return (
        <Fragment>
            <Header />

            <section className="instructor-single-section padding-tb section-bg">
                <div className="container" style={{marginTop:60}}>
                    <div className="row">

                        {/* ----- Left Sidebar: Ads ----- */}
                        <div className="col-lg-3">
                            <div className="ads-sidebar">
                                <h5 className="mb-3 text-center">🎯 Sponsored</h5>
                                {adsList.map((ad, i) => (
                                    <div className="ad-item mb-3" key={i}>
                                        <img src={ad.imgUrl} alt={ad.alt} className="w-100 rounded shadow-sm" />
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* ----- Main Content ----- */}
                        <div className="col-lg-9">
                            <div className="instructor-wrapper">

                                {/* ----- Tutor Top Info ----- */}
                                <div className="instructor-single-top">
                                    <div className="instructor-single-item d-flex flex-wrap justify-content-between">
                                        <div className="instructor-single-thumb">
                                            <img src={mainTutor.photo} alt={mainTutor.name} />
                                        </div>
                                        <div className="instructor-single-content">
                                            <h4 className="title">{mainTutor.name}</h4>
                                            <p className="ins-dege">{mainTutor.degree}</p>
                                            <Rating />
                                            <p className="ins-desc">{mainTutor.desc}</p>

                                            <h6 className="subtitle">{mainTutor.subTitle}</h6>
                                            <p className="ins-desc">{mainTutor.infoDetails}</p>

                                            <ul className="lab-ul" style={{ color: "#000000ff" }}>
                                                <li className="d-flex flex-wrap justify-content-start">
                                                    <span className="list-name">Address</span>
                                                    <span className="list-attr">{mainTutor.address}</span>
                                                </li>
                                                <li className="d-flex flex-wrap justify-content-start">
                                                    <span className="list-name">Email</span>
                                                    <span className="list-attr">{mainTutor.email}</span>
                                                </li>
                                                <li className="d-flex flex-wrap justify-content-start">
                                                    <span className="list-name">Phone</span>
                                                    <span className="list-attr">{mainTutor.phone}</span>
                                                </li>
                                                <li className="d-flex flex-wrap justify-content-start">
                                                    <span className="list-name">Website</span>
                                                    <span className="list-attr">{mainTutor.website}</span>
                                                </li>
                                                <li className="d-flex flex-wrap justify-content-start">
                                                    <span className="list-name">Category</span>
                                                    <span className="list-attr">{mainTutor.category}</span>
                                                </li>
                                                <li className="d-flex flex-wrap justify-content-start">
                                                    <span className="list-name">Specialization</span>
                                                    <span className="list-attr">{mainTutor.specialization}</span>
                                                </li>
                                                <li className="d-flex flex-wrap justify-content-start">
                                                    <span className="list-name">Experience</span>
                                                    <span className="list-attr">{mainTutor.experience}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                {/* ----- Skills & Awards ----- */}
                                <div className="instructor-single-bottom d-flex flex-wrap mt-4">
                                   <div className="d-flex flex-row flex-wrap">
                                        <h4 className="subtitle">Stage Performance Skills</h4>
                                        {skillList.map((val, i) => (
                                            <div className="text-center skill-item" key={i}>
                                                <div className="skill-thumb">
                                                    <Progress strokeWidth={8} percentage={val.percentage} />
                                                </div>
                                                <p>{val.text}</p>
                                            </div>
                                        ))}
                                    </div>
                                     </div>
                                     <div className="instructor-single-bottom d-flex flex-wrap mt-4">
                                    <div className="d-flex flex-row flex-wrap">
                                        <h4 className="subtitle">Recognitions / Awards</h4>
                                        {awardList.map((val, i) => (
                                            <div className="skill-item text-center" key={i}>
                                                <div className="skill-thumb">
                                                    <img src={`${val.imgUrl}`} alt={`${val.imgAlt}`} />
                                                </div>
                                                <p>{val.text}</p>
                                            </div>
                                        ))}
                                    </div>
                                    </div>
                                

                                {/* ----- Related Tutors Section ----- */}
                                <div className="related-tutors mt-5" style={{ backgroundColor: "#ffffff", padding: "20px", borderRadius: "10px" }}>
                                    <h4 className="subtitle mb-3">Other Tutors You May Like</h4>
                                    <div className="row g-4">
                                        {relatedTutors.map((tutor, i) => (
                                            <div className="col-lg-4 col-md-6" key={i}>
                                                <div className="tutor-item shadow-sm rounded p-3 text-center">
                                                    <img src={tutor.photo} alt={tutor.name} className="rounded-circle mb-2" style={{ width: "100px", height: "100px", objectFit: "cover" }} />
                                                    <h5>{tutor.name}</h5>
                                                    <p style={{ fontSize: "14px" }}>{tutor.category}</p>
                                                    <small style={{ color: "#666" }}>{tutor.experience}</small>
                                                    <Link to={tutor.link} className="d-block mt-2 lab-btn-text">
                                                        View Profile <i className="icofont-external-link"></i>
                                                    </Link>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </Fragment>
    );
};

export default StageTutor;
